import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
function LinkOverlayContainerComponent(props, ref) {
    const { children, component = 'div', ...rest } = props;
    const Component = component;
    return (_jsx(Component, { ref: ref, css: {
            position: 'relative',
            /* Elevate the inner links and abbreviations up */
            'a[href]:not(.ui__link__overlay), abbr[title]': {
                position: 'relative',
                zIndex: 1,
            },
        }, ...rest, children: children }));
}
/**
 * A component that contains a link overlay. Should be used with LinkOverlay.
 */
export const LinkOverlayContainer = React.forwardRef(LinkOverlayContainerComponent);
